/**
 * @param {import(Vuex).Store} $store
 * @returns {{show(*): void}}
 * @constructor
 */
export function LightBoxManager($store) {
  let blobImage = null;

  return {
    show(image) {
      $store.commit("lightBox/show", image);
    },

    showBlob(blob) {
      blobImage = URL.createObjectURL(blob);
      $store.commit("lightBox/show", blobImage);
    },

    close() {
      if (blobImage !== null) {
        URL.revokeObjectURL(blobImage);
        blobImage = null;
      }

      $store.commit("lightBox/show", null);
    },
  };
}
